// extracted by mini-css-extract-plugin
export default {"semesters":"D5pWLDZQ","sem1":"BkKMoaJp","sem2":"JKkl7o_b","sem3":"eN328qxy","sem4":"l2x7TU0n"};